"use client"

import {
  PortableText as PortableTextComponent,
  type PortableTextComponents,
  type PortableTextBlock,
} from "@portabletext/react"

import {
  ImageBlock,
  CodeBlockSimple,
  CalloutBlock,
  DiagramBlock,
  ComparisonTableBlock,
} from "@/core/components/sanity-custom-types"

const proseComponents: PortableTextComponents = {
  types: {
    image: ({ value }) => <ImageBlock value={value} className="my-8" />,
    codeBlock: ({ value }) => <CodeBlockSimple value={value} />,
    callout: ({ value }) => <CalloutBlock value={value} />,
    diagram: ({ value }) => <DiagramBlock value={value} />,
    comparisonTable: ({ value }) => <ComparisonTableBlock value={value} />,
  },
  // We leave block and marks to their defaults so they render raw <h2>, <p>, <strong>, etc.
  // Tailwind Typography (.prose) will style them natively.
}

interface SanityProseTextProps {
  value: PortableTextBlock[]
}

export function SanityProseText({ value }: SanityProseTextProps) {
  return <PortableTextComponent value={value} components={proseComponents} />
}
